module.exports = __webpack_public_path__ + "static/story-with-name-4ac7ab5790e4168754a117d37b35145a.png";